class IP {
    getIp() {

        // 빌드시
        // return "http://nanjingsrm.georimtech.com"

        // 테스트시
        // return "http://localhost";   // ip는 localhost 로 맞춰주기

        return ""
    }
}
export default new IP();

